import axios from "axios";
import { config } from "../../Utils/helpers";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const AddHomeCategory = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "HOME_CATEGORY_ADD_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/home-category/add`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "HOME_CATEGORY_ADD_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "HOME_CATEGORY_ADD_FAIL",
                    payload: data.message || "Add failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "HOME_CATEGORY_ADD_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const UpdateHomeCategory = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: "HOME_CATEGORY_UPDATE_REQUEST" });

            const { data } = await axios.post(
                `${BASE_URL}/home-category/update`,
                payload,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "HOME_CATEGORY_UPDATE_SUCCESS",
                    payload: data,
                });
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: "HOME_CATEGORY_UPDATE_FAIL",
                    payload: data.message || "Update failed",
                });
                return Promise.reject(new Error(data.message));
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Network error";
            dispatch({
                type: "HOME_CATEGORY_UPDATE_FAIL",
                payload: errorMessage,
            });
            return Promise.reject(new Error(errorMessage));
        }
    };
};

export const ViewHomeCategory = () => {
    return async (dispatch) => {
        try {
            dispatch({ type: "HOME_CATEGORY_VIEW_REQUEST" });

            const { data } = await axios.get(
                `${BASE_URL}/home-category/view`,
                config
            );

            if (data.statusCode === 200) {
                dispatch({
                    type: "HOME_CATEGORY_VIEW_SUCCESS",
                    payload: data,
                });
            } else {
                dispatch({
                    type: "HOME_CATEGORY_VIEW_FAIL",
                    payload: data,
                });
            }
        } catch (error) {
            dispatch({
                type: "HOME_CATEGORY_VIEW_FAIL",
                payload: error?.response?.data?.message,
            });
        }
    };
};